module.exports = __webpack_public_path__ + "a7fbef270d77a76478419d17b332ae2d.png";